export * from './src/places-view.component';
